import React, { useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import DashAuthWrapper from './../components/DashAuthWrapper'
import { fetchServicesStart } from './../redux/VendorServices/vendor.actions';
import { fetchCustomersStart } from '../redux/User/user.actions';
import { fetchApptsStart } from '../redux/Appointments/appts.actions';
import {format} from 'date-fns'

const mapState = ({ apptsData, user }) => ({
	customers: user.customers,
	appts: apptsData.appts,
	currentUser: user.currentUser
})

const VendorApptsDetails = props => {
	const { appts, customers, currentUser } = useSelector(mapState);
	const dispatch = useDispatch();
	const history = useHistory();

	const { customersData } = customers;
	const { apptData } = appts;

	useEffect(() => {
		dispatch(
			fetchServicesStart()
		);
		dispatch(
			fetchApptsStart()
		);
		dispatch(
			fetchCustomersStart()
		);
		window.scrollTo(0, 0)
		// eslint-disable-next-line
	}, []);
	
	//only show subscribed customers
	const subscribedCustomers = [];
	if(Array.isArray(customersData)){
		for(let i = 0; i < customersData.length; i++){
			if(customersData[i].subscribed ){
				subscribedCustomers.push(customersData[i]);
			}
		}
	}
	//filter appts by vendorID
	const apptsByVendorID = [];
	if(Array.isArray(apptData)){
		for(let i = 0; i < apptData.length; i++){
			if(apptData[i].vendorsID === `${currentUser.id}` ){
				apptsByVendorID.push(apptData[i]);
			}
		}
	}
	
	
	return (
		<DashAuthWrapper>
			<div className="pb-5">
				<h2 className="text-primary">Create Appointment</h2>
				<div className="cart">
					<table border="0" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td>
									<table className="convoHeader" border="0" cellPadding="10" cellSpacing="0">
										<tbody >
										<tr >
											<th className="pr-0">
											Customer
											</th>
										
											<th className="pl-0 pr-o ml-0">
											Address
											</th>
										
											<th >
											
											</th>
										</tr>
										</tbody>
									</table>
								</td>
							</tr>
							<tr>
								<td>
									<table className="convoResults" border="0" cellPadding="10" cellSpacing="0">
									<tbody>
									
										{(Array.isArray(subscribedCustomers) && subscribedCustomers.length > 0) && subscribedCustomers.map((customer, index) => {
											const {
												displayName,
												fullAddress,
												documentID
											} = customer;
											
											return (
												<tr key={index}>
												
												<td>
													{displayName}
												</td>
												<td className="text-capitalize">
													<button className="btn" onClick={() => history.push(`/customerMap/${fullAddress}/`)}>Map Location</button>
												</td>
												<td className="text-right">
													<button className="btn" onClick={() => history.push(`/vendorAppointment/${documentID}/`)}>Create Appt</button>
												</td>
												
												</tr>
											)
										})}

									</tbody>
									</table>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div className="manageAppts mt-5 pb-5">
				<hr></hr>
				<h2 className="text-primary">Manage Appointments</h2>
				<hr></hr>
				<div className="cart">
					<table border="0" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td>
									<table className="convoHeader" border="0" cellPadding="10" cellSpacing="0">
										<tbody >
										<tr >
											<th className="pr-0">
												Service
											</th>
										
											<th className="pl-0 pr-o ml-0">
												Date
											</th>

											<th className="pl-0 pr-o ml-0">
												Customer
											</th>
										
											<th >
											
											</th>
										</tr>
										</tbody>
									</table>
								</td>
							</tr>
							<tr>
								<td>
									<table className="convoResults" border="0" cellPadding="10" cellSpacing="0">
									<tbody>
									
										{(Array.isArray(apptsByVendorID) && apptsByVendorID.length > 0) && apptsByVendorID.map((appt, index) => {
											const {
												startDate,
												productName,
												custsID,
												custName

											} = appt;
											
											return (
												<tr key={index}>
												
												<td>
													{productName}
												</td>
												
												<td >
												{format(startDate.toDate(), 'MMM dd, yyyy ')} 
												</td>

												<td>
													{custName}
												</td>

												<td className="text-right">
													<button className="btn" onClick={() => history.push(`/vendorAppointment/${custsID}/`)}>Details</button>
												</td>

												
												</tr>
											)
										})}

									</tbody>
									</table>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</DashAuthWrapper>


		
	)
}

export default VendorApptsDetails;